// extracted by mini-css-extract-plugin
export default {"ShipmentWrapper":"Shipment_ShipmentWrapper__qML-d","descriptionWrapper":"Shipment_descriptionWrapper__mQE6-","description":"Shipment_description__JvZVp"};